import Cookie from 'js-cookie';
import getConfig from 'next/config';
import isProduction from './isProduction';

export const ENVIRONMENT_COOKIE_NAME = 'environment';

/**
 * Empty string if production environment; otherwise, use default (data) environment
 */
export default function getDataEnvironment(): string {
  const { publicRuntimeConfig } = getConfig();
  return isProduction(publicRuntimeConfig.ENVIRONMENT_NAME)
    ? ''
    : Cookie.get(ENVIRONMENT_COOKIE_NAME) || publicRuntimeConfig.DEFAULT_ENVIRONMENT;
}
